// AuthenticatedLayout.js
import React from "react";
import Navbar from "../Navbar/index";
import Breadcrumb from "../Breadcrumb";

const AuthenticatedLayout = ({ children }) => {
  return (
    <>
      <div>
        <div className="flex-1 flex dark:bg-gray-700 min-w-screen min-h-screen">
          <Navbar className="z-30"/>
          <div className="md:w-60 w-20 ">
            {" "}
            {/* Sidebar */}
          </div>
          <div className=" lg:w-[calc(100vw-140px)] md:w-[calc(100vw-280px)] w-[calc(100vw-70px)] sm:w-[calc(100vw-70px)] md:mr-2 sm:ml-0 md:ml-0 mt-[40px] mb-10 mr-2 lg:mr-4 bg-white dark:bg-gray-700">
            <Breadcrumb/>
            {" "}
            {/* Main Content */}
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthenticatedLayout;
